import { createArray } from 'helpers';
import * as setup from 'setup';
import Ant from './Ant';

export default class AntWarrior extends Ant {

    constructor(gameState: GameState, props?: AntProps, state?: any) {
        super(gameState, 'warrior', setup.ants.warrior, {
            ...props,
            movingTextures: createArray(15, i => `ant/warrior/ant-warrior-moving-${i + 1}.png`),
        }, state);

        // Initialize
        this.zIndex = 4;
    }

    init = () => {
        this.onMove();
        this.findTarget();
    }

    findTarget = () => {
        // Check paradise
        if (this.gameState.unlocks.paradise) {
            return this.moveToParadise();
        }

        // Get closest DangerAnt
        const targets = [
            this.gameState.entities.dangers.antWarriors.active,
            this.gameState.entities.dangers.antWorkers.active,
        ];
        this.target = this.getClosestPreferredTarget(targets);

        // Attack target if close enough, otherwise move
        if (this.target && this.isCloseToTarget(this.target)) {
            this.attackTarget(this.target, this.findTarget);
        } else if (this.target?.getClosestTarget(this.gameState.entities.ants.workers.active, this.setup.searchDistance)) {
            this.moveToTarget(this.target, this.findTarget);
        } else {
            // Get closest AntWorker
            const closestWorker = this.getClosestTarget(this.gameState.entities.ants.workers.active);
            if (closestWorker) {
                this.wanderTo(closestWorker.cell, 0.7, this.findTarget);
            } else {
                this.wanderTo(this.colony.cell, 0, this.findTarget);
            }
        }
    }
}